// Copyright 2025, University of Maryland, All Rights Reserved
import { memo, type FC } from 'react'
import { FileText } from 'lucide-react'

import { BaseNode } from '@/subsystems/pipelines'
import type { NodeAdminViewProps } from '../../../core/types'
import { AnalysisNodeShell } from '../shared/AnalysisNodeShell'

export const AnalysisSummaryWorkflowNode = memo(() => (
  <BaseNode
    icon={<FileText />}
    label="Analysis Summary"
    hasInput
    hasOutput
  />
))

AnalysisSummaryWorkflowNode.displayName = 'AnalysisSummaryWorkflowNode'

export const AnalysisSummaryAdminView: FC<NodeAdminViewProps> = props => {
  const { orgId, workspaceId, nodeInstanceId, config, onChange } = props

  return (
    <AnalysisNodeShell
      orgId={orgId}
      workspaceId={workspaceId}
      nodeInstanceId={nodeInstanceId}
      config={config}
      onChange={onChange}
      title="Analysis Summary"
      description="Summarize upstream extraction output with a focused prompt and dataset target."
      mode="summary"
      allowedDatasourceTypes={['analysis_results']}
    />
  )
}
